import { Checkbox } from "@shopify/polaris";
import React from "react";
import { reducerFn } from "../../helper";
import { BulkActions } from "../shared/BulkActions";
import { BulkActionStore } from "./BulkActionStore";
import { calcuItemCheck, getCheckAllItems } from "./utils";

const initialValues = { checkAll: false, itemsChecked: [] };
const SelectRowsContext = React.createContext({
  ...initialValues,
  checkAllMarkup: null,
  checkItemMarkup: () => {},
});

export const SelectRowsProvider = ({
  children,
  data,
  refetch,
  isChildNode,
}) => {
  const [state, setState] = React.useReducer(reducerFn, initialValues);

  const handleCheckAll = (value) => {
    setState({ itemsChecked: getCheckAllItems(data, value), checkAll: value });
  };

  const handleItemCheck = (newChecked, id) => {
    setState((p) => {
      return {
        ...p,
        ...calcuItemCheck(p.itemsChecked, id, newChecked),
      };
    });
  };

  const handleCompleted = async () => {
    setState(initialValues);

    // fake time to close collapse
    await new Promise((res) => setTimeout(res, 1000));
    refetch && refetch();
  };

  const checkAllMarkup = (
    <Checkbox checked={state.checkAll} onChange={handleCheckAll} />
  );

  const checkItemMarkup = (value) => (
    <div className="check-box-wrap">
      <Checkbox
        id={value}
        checked={state.itemsChecked.includes(value)}
        onChange={handleItemCheck}
      />
    </div>
  );

  const bag = {
    checkAllMarkup,
    ids: state.itemsChecked,
    checkItemMarkup,
    onCompleted: handleCompleted,
  };

  return (
    <SelectRowsContext.Provider value={bag}>
      <BulkActions
        idsChecked={state.itemsChecked}
        onClose={() => handleCheckAll(false)}
      >
        <BulkActionStore />
      </BulkActions>
      {isChildNode ? children : children(bag)}
    </SelectRowsContext.Provider>
  );
};

export const useSelectRowsCtx = () => React.useContext(SelectRowsContext);
